import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { useCurrentBreakpoint } from "../../../../Shared/hooks/useCurrentBreakpoint";
export const DayFilterModuleSkeleton = ({ filterSettings }) => {
    var _a;
    const currentActiveBreakpoint = useCurrentBreakpoint();
    // Iterate over all responsive settings in filterSettings to find a match for the current active breakpoint
    const matchingResponsive = (_a = filterSettings.responsive) === null || _a === void 0 ? void 0 : _a.reduce((acc, curr) => {
        if (currentActiveBreakpoint.value == curr.breakpoint) {
            return !acc || curr.breakpoint < acc.breakpoint ? curr : acc;
        }
        return acc;
    }, undefined);
    // If no match is found, use the default slidesToShow value
    const boxesToShow = matchingResponsive ? matchingResponsive.settings.slidesToShow : filterSettings.slidesToShow;
    return (_jsx(_Fragment, { children: _jsxs(Stack, Object.assign({ direction: "row", justifyContent: "center", alignItems: "center", width: "100%" }, { children: [filterSettings.arrows && _jsx(Skeleton, { style: { margin: "5px" }, variant: "rectangular", width: 24, height: 24 }), Array.from({ length: boxesToShow }, (_, index) => (_jsx(Skeleton, { style: { margin: "5px" }, variant: "rectangular", width: 172, height: 60 }, index))), filterSettings.arrows && _jsx(Skeleton, { style: { margin: "5px" }, variant: "rectangular", width: 24, height: 24 })] })) }));
};
